import { Message } from '@backend/domain'
import { Injectable } from '@nestjs/common'
import { InjectRepository } from '@nestjs/typeorm'
import { Repository } from 'typeorm'
import { UserModifiableEntityRepository } from './generic'

@Injectable()
export class MessageRepository extends UserModifiableEntityRepository<Message> {
	constructor(@InjectRepository(Message) override readonly _repository: Repository<Message>) {
		super(_repository)
	}
}
